import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {SharedConfigModel} from "../models/shared-config.model";

@Injectable({
  providedIn: 'root'
})
export class SharedConfigService {

  constructor(private http: HttpClient) {
  }

  public getConfig(): Promise<SharedConfigModel> {
    // The config.json file is copied under the root/assets folder as described in the angular.json file
    return new Promise((resolve, reject) => {
      this.http.get<SharedConfigModel>(`assets/config.json`)
        .subscribe(
          (config) => {
            resolve(config);
          },
          (error) => {
            reject(error);
          }
        )
    });
  }
}
